<template>
  <body id="home-page">
    <router-view></router-view>
    <vue-toastr ref="toastr"></vue-toastr>
  </body>
</template>

<script>
export default {
  name: "app", // eslint-disable-line
  mounted() {
    this.$refs.toastr.defaultPosition = "toast-bottom-right";
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?8a071142